import React, { useEffect, useState } from "react";
import Content from "../layout/content/Content";
import Head from "../layout/head/Head";
import { Badge, Button } from "reactstrap";
import { useNavigate } from "react-router";

const Cart = () => {
  const navigate = useNavigate();
  const [cart, setCart] = useState(0);
  const [cartData, setCartData] = useState([]);

  useEffect(() => {
    const storedCart = localStorage.getItem("cartValue");
    const storedCartData = localStorage.getItem("cartDataStore");

    if (storedCart) {
      setCart(parseInt(storedCart, 10)); // Initialize cart count
    }
    if (storedCartData) {
      const cartId = JSON.parse(storedCartData);
      setCartData(cartId);
    }
  }, []);

  const handleCheckOut = () => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/");
    } else {
      navigate("/checkout-message");
    }
  };

  const handleNavigate = (
    country_name,
    type_name,
    category,
    id,
    service__name
  ) => {
    const body = {
      country: country_name ? country_name : "",
      type: type_name ? type_name : "",
      category: category ? category : "",
      id: id,
      service__name: service__name ? service__name : "",
      filterName: "",
      selectCategory: "",
      page: "",
      selectCountries: "",
    };

    navigate(`/${type_name ? type_name : country_name}`, {
      state: body,
    });
  };

  const handleHome = () => {
    navigate("/");
  };

  return (
    <div>
      <Head title="Profile" />

      <Content>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div onClick={() => handleHome()} style={{ cursor: "pointer" }}>
            {" "}
            <img
              src="https://backendmarketplace.ahrvoid.com/media/logo_images/marketplace_BAHkiPW.png"
              alt="Logo"
              width={120}
            />
          </div>
          {/* {cart > 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                cursor: "pointer",
                alignItems: "center",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                fill="currentColor"
                className="bi bi-cart-check-fill"
                viewBox="0 0 16 16"
                style={{ color: "#1a2853" }}
              >
                <path d="M.5 1a.5.5 0 0 0 0 1h1.11l.401 1.607 1.498 7.985A.5.5 0 0 0 4 12h1a2 2 0 1 0 0 4 2 2 0 0 0 0-4h7a2 2 0 1 0 0 4 2 2 0 0 0 0-4h1a.5.5 0 0 0 .491-.408l1.5-8A.5.5 0 0 0 14.5 3H2.89l-.405-1.621A.5.5 0 0 0 2 1zM6 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0m7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1.646-7.646-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L8 8.293l2.646-2.647a.5.5 0 0 1 .708.708" />
              </svg>
              <div className="text-end">
                <span className="togal_count">{cart}</span>
              </div>
            </div>
          )} */}
           <div className="text-end">
          <Button
            className="check_out"
            style={{borderRadius:"7px"}}
            onClick={() => {
              handleCheckOut();
            }}
          >
            Checkout
          </Button>
        </div>
        </div>

        <div className="text-center">
          <h3 className="cart_title">Cart</h3>
        </div>

        <div className="mt-5" style={{ width: "80%", margin: "auto" }}>
          <table width="100%">
            <thead>
              <tr className="cart_row">
                <th>S. No.</th>
                <th>Logo</th>
                <th>Name</th>
                <th style={{ width: "38%" }}>Services</th>
              </tr>
            </thead>
            <tbody>
              {cartData.length > 0 ? (
                cartData.map((item, i) => (
                  <tr
                    key={item.id}
                    className="cart-item"
                    onClick={() =>
                      handleNavigate(
                        item?.country_name,
                        item?.name,
                        item?.category,
                        item?.id,
                        item?.service__name
                      )
                    }
                  >
                    <th className="sr_no">{i + 1}</th>
                    <td>
                      <img
                        src={item?.image ? item?.image : item?.apm_logo}
                        alt={item.name}
                        className="cart-image"
                        width={80}
                      />
                    </td>
                    <td className="cart-details">
                      <h3>{item?.name ? item?.name : item?.country_name}</h3>
                    </td>
                    <td>
                      {" "}
                      {item?.service__name == "Payment Gateways" && (
                        <Badge className="btn btn-primary mx-1  badge_name py-1 my-1">
                          Payment Gateways
                        </Badge>
                      )}
                      <Badge className="btn btn-primary mx-1  badge_name py-1 my-1">
                        {item?.category}
                      </Badge>
                      {item?.added_apm &&
                        item?.added_apm?.map((apm) => {
                          return (
                            <Badge className="btn btn-primary mx-1  badge_name py-1 my-1">
                              {apm?.value}
                            </Badge>
                          );
                        })}
                    </td>
                  </tr>
                ))
              ) : (
                <></>
              )}
            </tbody>
          </table>
        </div>
      </Content>
    </div>
  );
};

export default Cart;
